module.exports = __webpack_public_path__ + "static/media/why-we-choose-us.a7a375a8.png";